import { render, staticRenderFns } from "./add-paper-from-local.html?vue&type=template&id=368f746a&scoped=true&external"
import script from "./add-paper-from-local.js?vue&type=script&lang=js&external"
export * from "./add-paper-from-local.js?vue&type=script&lang=js&external"
import style0 from "./add-paper-from-local.scss?vue&type=style&index=0&id=368f746a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368f746a",
  null
  
)

export default component.exports